import { ExportRequestServiceMock } from "@/services";

export const mockExportRequestService = (): ExportRequestServiceMock => ({
  saveTransactionsExportRequest: jest.fn(),
  fetchExportRequests: jest.fn(),
  downloadExport: jest.fn(),
  canRequestExport: jest.fn(),
});
